// src/components/NewGameScreen.ts
import { SaveSystem } from '../systems/saveSystem.js';

export function NewGameScreen(opts: { onStart: () => void; onBack: () => void }): HTMLElement {
  const el = document.createElement('div');
  el.className = 'panel';
  el.innerHTML = `
    <div class="panel__head">
      <div class="kicker">Portal de inicio</div>
      <div class="h1" style="font-size:clamp(1.6rem,5vw,2rem)"><span>Nueva partida</span></div>
      <p class="subtitle">Elige cómo te llamarán en Aetheria. Podrás cambiarlo más adelante.</p>
    </div>
    <div class="panel__body">
      <div class="field">
        <label class="field__label" for="aetheria-name">Nombre del explorador</label>
        <input id="aetheria-name" class="input" type="text" maxlength="20" placeholder="Ej. Lira, Cael, Nova..." autocomplete="off" spellcheck="false" />
        <span style="font-size:.74rem;color:var(--faint)">2–20 caracteres. Se guarda localmente en esta fase.</span>
      </div>

      <div class="notice" style="margin-top:.9rem">
        <strong>Origen:</strong> Islas de Aurora · Prólogo. En la Fase 2 elegirás tu primera Asteria compañera.
      </div>

      <div class="world-preview" aria-hidden="true">
        <div class="world-preview__map">
          <div class="world-preview__grid"></div>
          <div class="world-preview__pin" style="left:34%;top:44%"></div>
          <svg viewBox="0 0 400 132" style="position:absolute;inset:auto 0 0 0;height:54px" preserveAspectRatio="none">
            <path d="M0 52 L60 36 L110 48 L160 22 L210 40 L260 18 L310 38 L360 26 L400 36 L400 132 L0 132 Z" fill="#0a1430" stroke="rgba(255,255,255,.08)" stroke-width="1"/>
          </svg>
        </div>
        <div class="world-preview__body">
          <div><div class="world-preview__title">Islas de Aurora</div><div class="world-preview__sub">Archipiélagos flotantes · Nivel 1–15</div></div>
          <span class="chip chip--warn">Prólogo</span>
        </div>
      </div>

      <div class="btn-row" style="margin-top:1rem">
        <button class="btn btn--primary" data-action="start" type="button">✦ Comenzar aventura</button>
        <button class="btn btn--ghost" data-action="back" type="button">← Volver al título</button>
      </div>
      <p style="margin-top:.75rem;text-align:center"><button data-action="clear" type="button" style="background:none;border:none;color:var(--faint);font-size:.76rem;text-decoration:underline;cursor:pointer">Borrar partida local (Fase 1)</button></p>
    </div>
  `;

  const input = el.querySelector<HTMLInputElement>('#aetheria-name')!;
  const startBtn = el.querySelector<HTMLButtonElement>('[data-action="start"]')!;
  const savedName = (() => {
    try {
      const s = SaveSystem.getState();
      return s.profile.name !== 'Explorador' ? s.profile.name : '';
    } catch {
      return '';
    }
  })();
  if (savedName) input.value = savedName;
  // autofocus con delay para transición
  window.setTimeout(() => input.focus(), 120);

  function doStart(): void {
    const raw = input.value.trim();
    const name = raw.length >= 2 ? raw.slice(0, 20) : 'Explorador';
    if (raw.length > 0 && raw.length < 2) {
      showInlineError('El nombre debe tener al menos 2 caracteres.');
      return;
    }
    SaveSystem.newGame(name);
    opts.onStart();
  }

  function showInlineError(msg: string): void {
    let err = el.querySelector<HTMLParagraphElement>('[data-role="error"]');
    if (!err) {
      err = document.createElement('p');
      err.dataset.role = 'error';
      err.style.cssText = 'margin-top:.6rem;color:var(--danger);font-size:.82rem;text-align:center';
      el.querySelector('.panel__body')!.appendChild(err);
    }
    err.textContent = msg;
    input.style.borderColor = 'rgba(255,92,122,.7)';
    window.setTimeout(() => (input.style.borderColor = ''), 1600);
  }

  startBtn.addEventListener('click', doStart);
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') doStart();
  });
  el.querySelector<HTMLButtonElement>('[data-action="back"]')!.addEventListener('click', opts.onBack);
  el.querySelector<HTMLButtonElement>('[data-action="clear"]')!.addEventListener('click', () => {
    try {
      localStorage.removeItem('aetheria:save:v1');
    } catch {}
    input.value = '';
    toast('Partida local borrada.');
  });

  return el;
}

function toast(msg: string): void {
  let stack = document.querySelector<HTMLDivElement>('.toast-stack');
  if (!stack) {
    stack = document.createElement('div');
    stack.className = 'toast-stack';
    document.body.appendChild(stack);
  }
  const t = document.createElement('div');
  t.className = 'toast';
  t.textContent = msg;
  stack.appendChild(t);
  window.setTimeout(() => t.remove(), 2600);
}
